import * as types from './actionTypes';
import relatorioApi from '../api/relatorioApi'

//Somente para armazenar os parametros de pesquisa no redux
export function ArmazenarParametrosRelatorioSuccess(relatorioParametros) {
    
    return { type: types.RELAT_PARAMETROS_PESQUISA, relatorioParametros }
}

export function ArmazenarParametrosRelatorio(relatorioParametros) {
    return function (dispatch) {
        
        return dispatch(ArmazenarParametrosRelatorioSuccess(relatorioParametros));
    };
}


export function ListarTotalMensagemPorClassificacaoPorIdEstruturaPaiSuccess(relatorioClassificacao) {
    
    return { type: types.RELAT_CLASSIFICACAO_ESTRUTURA, relatorioClassificacao }
}

export function ListarTotalMensagemPorClassificacaoPorIdEstruturaPai(parametros) {
    return function (dispatch) {
        return relatorioApi.ListarTotalMensagemPorClassificacaoPorIdEstruturaPai(parametros).then(resultado => {
            
            dispatch(ListarTotalMensagemPorClassificacaoPorIdEstruturaPaiSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}

export function ListarTotalMensagemPorClassificacaoPorIdEstruturaPaiPorAssuntoSuccess(relatorioClassificacaoPorAssunto) {
    
    return { type: types.RELAT_CLASSIFICACAO_ESTRUTURA_POR_ASSUNTO, relatorioClassificacaoPorAssunto }
}

export function ListarTotalMensagemPorClassificacaoPorIdEstruturaPaiPorAssunto(parametros) {
    return function (dispatch) {
        return relatorioApi.ListarTotalMensagemPorClassificacaoPorIdEstruturaPai(parametros).then(resultado => {
            
            dispatch(ListarTotalMensagemPorClassificacaoPorIdEstruturaPaiPorAssuntoSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}


export function ListarTotalMensagemPorSituacaoEstruturaSuccess(relatorioSituacao) {
    
    return { type: types.RELAT_SITUACAO_ESTRUTURA, relatorioSituacao }
}

export function ListarTotalMensagemPorSituacaoEstrutura(parametros, tipicasOuvidoria) {
    return function (dispatch) {
        return relatorioApi.ListarTotalMensagemPorSituacaoEstrutura(parametros, tipicasOuvidoria).then(resultado => {
            
            dispatch(ListarTotalMensagemPorSituacaoEstruturaSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}



export function ListarTempoRespostaPorFaixaSuccess(relatorioTempoRespostaFaixa) {
    
    return { type: types.RELAT_TEMPO_RESPOSTA_FAIXA, relatorioTempoRespostaFaixa }
}

export function ListarTempoRespostaPorFaixa(parametros, tipicasOuvidoria) {
    return function (dispatch) {
        return relatorioApi.ListarTempoRespostaPorFaixa(parametros, tipicasOuvidoria).then(resultado => {
            
            dispatch(ListarTempoRespostaPorFaixaSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}

export function ListarTempoRespostaClassificacaoPorFaixaSuccess(relatorioTempoRespostaClassificacaoFaixa) {
    
    return { type: types.RELAT_TEMPO_RESPOSTA_CLASSIFICACAO_FAIXA, relatorioTempoRespostaClassificacaoFaixa }
}

export function ListarTempoRespostaClassificacaoPorFaixa(parametros, tipicasOuvidoria) {
    return function (dispatch) {
        return relatorioApi.ListarTempoRespostaClassificacaoPorFaixa(parametros, tipicasOuvidoria).then(resultado => {
            
            dispatch(ListarTempoRespostaClassificacaoPorFaixaSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}


export function ObterQuantitativoManifestacoesIntervaloAnoSuccess(relatorioQuantitativoIntervaloAno) {
    
    return { type: types.RELAT_QUANTITATIVO_INTERVALO_ANO, relatorioQuantitativoIntervaloAno }
}

export function ObterQuantitativoManifestacoesIntervaloAno(parametros, tipicasOuvidoria, anos) {
    return function (dispatch) {
        return relatorioApi.ObterQuantitativoManifestacoesIntervaloAno(parametros, tipicasOuvidoria, anos).then(resultado => {
            
            dispatch(ObterQuantitativoManifestacoesIntervaloAnoSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}


export function IndicadorTempoRespostaPorFaixaSuccess(relatorioIndicadorTempoRespostaFaixa) {
    
    return { type: types.RELAT_INDICADOR_TEMPO_RESPOSTA_FAIXA, relatorioIndicadorTempoRespostaFaixa }
}

export function IndicadorTempoRespostaPorFaixa(parametros) {
    return function (dispatch) {
        return relatorioApi.IndicadorTempoRespostaPorFaixa(parametros).then(resultado => {
            
            dispatch(IndicadorTempoRespostaPorFaixaSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}

export function IndicadorNivelClassificacaoSuccess(relatorioIndicadorNivelClassificacao) {
    
    return { type: types.RELAT_INDICADOR_NIVEL_CLASSIFICACAO, relatorioIndicadorNivelClassificacao }
}

export function IndicadorNivelClassificacao(parametros) {
    return function (dispatch) {
        return relatorioApi.IndicadorNivelClassificacao(parametros).then(resultado => {
            
            dispatch(IndicadorNivelClassificacaoSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}

export function ListarAssuntosPorClassificacaoEstruturaSuccess(relatorioAssuntoCassificacaoEstrutura) {
    
    return { type: types.RELAT_ASSUNTO_POR_NATUREZA_ESTRUTURA, relatorioAssuntoCassificacaoEstrutura }
}

export function ListarAssuntosPorClassificacaoEstrutura(parametros) {
    return function (dispatch) {
        return relatorioApi.ListarAssuntosPorClassificacaoEstrutura(parametros).then(resultado => {
            
            dispatch(ListarAssuntosPorClassificacaoEstruturaSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}

export function ListarTop5AssuntosEstruturaSuccess(relatorioTop5Assunto) {
    
    return { type: types.RELAT_TOP5_ASSUNTO, relatorioTop5Assunto }
}

export function ListarTop5AssuntosEstrutura(parametros) {
    return function (dispatch) {
        return relatorioApi.ListarTop5AssuntosEstrutura(parametros).then(resultado => {
            
            dispatch(ListarTop5AssuntosEstruturaSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}

export function ListarAssuntosComTotalHierarquicoSuccess(relatorioHierarquiaAssunto) {
    
    return { type: types.RELAT_HIERARQUIA_ASSUNTO, relatorioHierarquiaAssunto }
}

export function ListarAssuntosComTotalHierarquico(parametros, tipicasOuvidoria, idAssuntoPai) {
    return function (dispatch) {
        return relatorioApi.ListarAssuntosComTotalHierarquico(parametros, tipicasOuvidoria, idAssuntoPai).then(resultado => {
            
            dispatch(ListarAssuntosComTotalHierarquicoSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}
export function ListarAssuntosComTotalHierarquicoPorNaturezaSuccess(relatorioHierarquiaAssuntoPorNatureza) {
    
    return { type: types.RELAT_HIERARQUIA_ASSUNTO_POR_NATUREZA, relatorioHierarquiaAssuntoPorNatureza }
}

export function ListarAssuntosComTotalHierarquicoPorNatureza(parametros, tipicasOuvidoria, idAssuntoPai) {
    return function (dispatch) {
        return relatorioApi.ListarAssuntosComTotalHierarquico(parametros, tipicasOuvidoria, idAssuntoPai).then(resultado => {
            
            dispatch(ListarAssuntosComTotalHierarquicoPorNaturezaSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}

export function ListarEstruturasComTotalHierarquicoSuccess(relatorioHierarquiaEstrutura) {
    
    return { type: types.RELAT_HIERARQUIA_ESTRUTURA, relatorioHierarquiaEstrutura }
}

export function ListarEstruturasComTotalHierarquico(parametros, tipicasOuvidoria, idEstruturaPai) {
    return function (dispatch) {
        return relatorioApi.ListarEstruturasComTotalHierarquico(parametros, tipicasOuvidoria, idEstruturaPai).then(resultado => {
            
            dispatch(ListarEstruturasComTotalHierarquicoSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}
export function ListarDirecionamentoGrupoTratamentoSuccess(rel) {
    
    return { type: types.RELAT_DIRECIONAMENTO_GRUPOTRATAMENTO, payload:rel }
}

export function ListarDirecionamentoGrupoTratamento(parametros) {
    return function (dispatch) {
        return relatorioApi.ListarDirecionamentoGrupoTratamento(parametros).then(resultado => {
            
            dispatch(ListarDirecionamentoGrupoTratamentoSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}




/** WEBPACK FOOTER **
 ** ./src/components/actions/relatorioActions.js
 **/